import { homeApi } from "@/api/homeApi";
import prognosisDao from "@/api/prognosisDao";
import {
  CardOfTheDayDomain,
  mapCardOfTheDayDbToDomain,
  mapCardOfTheDayDomainToDb,
  mapCardOfTheDayDtoToDomain,
} from "@/types/Card";
import { selectCardOfTheDay } from "@/api/cardOftheDayApi";
import { isResetPassed } from "@/utils/timerUtils";

interface CardOfTheDayRepository {
  getCardOfTheDay: () => Promise<CardOfTheDayDomain | null>;
  selectCardOfTheDay: (position: number) => Promise<void>;
  clearCardOfTheDay: () => void;
}

const cardOfThedayRepository: CardOfTheDayRepository = {
  selectCardOfTheDay: async (position: number): Promise<void> => {
    await selectCardOfTheDay(position);
  },

  getCardOfTheDay: async (): Promise<CardOfTheDayDomain | null> => {
    const dbCardOfTheDayDb = prognosisDao.getCardOfTheDay();
    const dbCardOfTheDay = dbCardOfTheDayDb
      ? mapCardOfTheDayDbToDomain(dbCardOfTheDayDb)
      : null;

    const newDate = dbCardOfTheDay?.resetDate ?? null;

    const isResetDatePassed = isResetPassed(newDate);

    if (isResetDatePassed || !dbCardOfTheDayDb) {
      prognosisDao.clearCardOfTheDay();
      const homeInfo = await homeApi.getMainMenu();

      if (!homeInfo.cardOfTheDay || !homeInfo.cardOfTheDayResetDate) {
        return null;
      }

      const newCardOfTheDayDomain = mapCardOfTheDayDtoToDomain(
        homeInfo.cardOfTheDay,
        homeInfo.cardOfTheDayResetDate
      );
      prognosisDao.saveCardOfTheDay(
        mapCardOfTheDayDomainToDb(newCardOfTheDayDomain)
      );
      return newCardOfTheDayDomain;
    }

    return dbCardOfTheDay;
  },

  clearCardOfTheDay: () => {
    prognosisDao.clearCardOfTheDay();
  },
};

export default cardOfThedayRepository;
